import { useState } from "react";
import { useParams } from "react-router-dom";

const Form = ({inputs, sendData}) => {
    const [texts, setTexts] = useState(Array(inputs.length).fill(""));
    const [error_matrix, setErrorMatrix] = useState(Array(inputs.length).fill([]));

    const noErrors = (errors) => {
        for (let i_errors of errors) {
            if (i_errors.length !== 0) {
                return false;
            }
        }
        return true;
    }

    const submit = (event) => {
        event.preventDefault();

        let errors = [];

        for (let i = 0; i < inputs.length; i++) {
            let i_errors = [];
            for (let req of inputs[i].reqs) {
                const splits = req.split(" ");
                switch(splits[0]) {
                    case "min":
                        if (texts[i].length < parseInt(splits[1])) {
                            i_errors.push(`Should be at least ${splits[1]} characters long`);
                        }
                        break;
                    case "max":
                        if (texts[i].length > parseInt(splits[1])) {
                            i_errors.push(`Should be less than ${splits[1]} characters long`);
                        }
                        break;
                    case "upper":
                        if (!/[A-Z]/.test(texts[i])) {
                            i_errors.push(`Should include uppercase letters`);
                        }
                        break;
                    case "lower":
                        if (!/[a-z]/.test(texts[i])) {
                            i_errors.push(`Should include lowercase letters`);
                        }
                        break;
                    case "num":
                        if (!/[0-9]/.test(texts[i])) {
                            i_errors.push(`Should include numbers`);
                        }
                        break;
                    case "confirm":
                        if (texts[i] !== texts[inputs.findIndex(input => input.name === splits[1])]) {
                            i_errors.push("Does not match");
                        }
                        break;
                }
            }
            errors.push(i_errors);
        }

        if (noErrors(errors)) {
            sendData(texts);
        } else {
            setErrorMatrix(errors);
        }
    }
    
    const updateTexts = (i, text) => {
        let newTexts = texts;
        newTexts[i] = text;
        setTexts(newTexts);
    }

    const types = inputs.map(input => input.isPassword ? "password" : "text");

    return <form className="flex flex-col">
        {inputs.map((input, i) => <div className="flex flex-col">
            <input
                className="input input-bordered input-accent"
                type={types[i]}
                placeholder={input.placeholder}
                onChange={e => updateTexts(i, e.target.value)}
            />
            {error_matrix[i].map(error => <div>
                {error}
            </div>)}
        </div>)}
        <button onClick={e => submit(e)}>Submit</button>
    </form>
}

export default Form;